import omnivore from '@mapbox/leaflet-omnivore'
import 'leaflet'
import 'leaflet.markercluster'
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import Chart from 'chart.js/auto';
import { getRelativePosition } from 'chart.js/helpers';
import {isEmpty} from "lodash";
import { install } from "resize-observer";

if (!window.ResizeObserver) install();

const carto = (stops = [], kmlFile = null, types = {}) => {

    // carte OpenStreeMap
    let openStreeMapLayer = openStreetMapTileLayer();
    // carte IGN
    let ignLayer = ignTileLayer();
    //layer du tracé
    let markersLines = L.markerClusterGroup();
    //layer des point d'interets
    let markersPOI = {};
    //coordonnées du tracé
    let coordinates = [];
    //layer des stops de l'app
    let markers = L.markerClusterGroup();
    //tracé altimetrique
    let chartMarker = null;
    //calcul de distance
    let distance = {
        lastCoordinates: null,
        distance: 0
    }
    // control case à cocher
    var overlayMaps = {
        "Hébergements": markers,
        "Tracé du GR": markersLines
    };
    //les types de données affichés
    let layersType = {
        "stop": markers,
        "gr": markersLines
    };
    //control fond de carte
    var baseMaps = {
        "OpenStreetMap": openStreeMapLayer,
        "IGN": ignLayer,
    };
    let chart = null;
    // initialize the map on the "map" div with a given center and zoom
    let map = L.map('map', {
        center: [46.671203, 3.3083],
        zoom: 9,
        layers: [ignLayer],
        scrollWheelZoom: true
    });

    //affichage du KML
    let kml = omnivore.kml(kmlFile, null, L.geoJson(null, {
        onEachFeature: function (feature, layer) {
            if (feature.geometry.type == 'LineString') {

                layer.on('mousemove', function(e) {
                    let x = coordinates.findIndex((current)=>{
                       return L.latLng(e.latlng).distanceTo(L.latLng(current[1], current[0])) < 100 &&
                           (toFixed(e.latlng.lat,2) == toFixed(current[1], 2) && toFixed(e.latlng.lng, 2) == toFixed(current[0], 2))
                    })
                    moveMarker(e.latlng)
                    if(x >= 0) {
                        triggerTooltip(coordinates[x][3])
                    }
                });
                markersLines.addLayer(layer)
                coordinates = coordinates.concat(feature.geometry.coordinates);
            } else if (feature.geometry.type == 'Point') {
                if (markersPOI[feature.properties.type] === undefined) {
                    markersPOI[feature.properties.type] = L.markerClusterGroup();
                }
                layer.bindPopup("<p>"+feature.properties.name + "</p>");
                let type = types[feature.properties.type];
                if(type !== undefined){
                    layer.setIcon(getIcon(type.icon, type.color))
                }
                markersPOI[feature.properties.type].addLayer(layer);
            }
        }
    }));
    kml.on('ready', function () {
        Object.entries(markersPOI).map(function (entry) {
            let type = types[entry[0]];
            //map.addLayer(entry[1]);
            if(type) {
                overlayMaps[type.label] = entry[1];
                layersType[entry[0]] = entry[1];
            }
        })

        map.addLayer(markersLines);
        initChart(coordinates);
        //L.control.layers(baseMaps, overlayMaps).addTo(map);
        Object.entries(layersType).map((item)=> {
            let type = types[item[0]]
            let label = document.createElement('label')
            label.setAttribute('class', 'btn btn-primary btn-lg btn-square');
            let newContent = document.createTextNode(type.label);
            let checkbox = document.createElement('input');
            checkbox.setAttribute('type', 'checkbox');
            checkbox.setAttribute('value', item[0]);
            checkbox.checked = map.hasLayer(item[1]);
            checkbox.addEventListener('change', (event) => {
                let layer = layersType[event.target.value]
                if (!event.target.checked && map.hasLayer(layer)) {
                    layer.remove(map);
                } else {
                    layer.addTo(map);
                }
            })
            label.appendChild(checkbox)
            label.appendChild(newContent)
            let parent = document.getElementById('control-bar');
            parent.appendChild(label)
        })
    })


    //affichage des stops de l'app
    stops.map(function (stop) {
        markers.addLayer(L.marker([stop.latitude, stop.longitude], {
            title: stop.title,
            icon:  getIcon(types['stop'].icon, types['stop'].color)
        }
        ).bindPopup("<p><strong>" + stop.title + "</strong></p><p>" + stop.address + "</p>"));
    })
    let bounds = markers.getBounds();
    map.fitBounds(bounds);
    map.addLayer(markers);

    function moveMarker(coordinates) {
        if (chartMarker) {
            map.removeLayer(chartMarker)
        }

        chartMarker = L.marker(Array. isArray(coordinates) ? [coordinates[1], coordinates[0]] : coordinates, {icon: getIcon(types['marker'].icon, types['marker'].color)});
        chartMarker.addTo(map)
    }

    function triggerTooltip(x) {
        let meta = chart.getDatasetMeta(0),
            rect = chart.canvas.getBoundingClientRect(),
            metaData = meta.data[x];

        if(!isEmpty(metaData)) {
            let point = metaData.getCenterPoint(),
                evt = new MouseEvent('mousemove', {
                    clientX: rect.left + point.x,
                    clientY: rect.top + point.y,
                    relatedTarget: document.getElementById('map')
                }),
                node = chart.canvas;
            node.dispatchEvent(evt);
        }
    }

    function initChart(coordinates) {
        let xAxis = [];
        let yAxis = [];
        let tempData = []
        coordinates.map((point) => {
            if(distance.lastCoordinates != null){
                let temp = L.latLng(distance.lastCoordinates[1], distance.lastCoordinates[0]).distanceTo(L.latLng(point[1], point[0]));
                distance.distance += temp
            }
            distance.lastCoordinates = point
            point.push(Math.round(distance.distance/1000));
            tempData.push(point);
        })

        let lastKm = null;
        for (let i = 0; i < tempData.length; i++){
            if(lastKm !== tempData[i][3]) {
                xAxis.push(tempData[i][3])
                yAxis.push(tempData[i])
                lastKm = tempData[i][3];
            } else if(i == tempData.length -1){
                xAxis.push(tempData[i][3]+1)
                yAxis.push(tempData[i])
            }
        }

        chart = new Chart(document.getElementById("chart"), {
            type: 'line',
            data: {
                labels: xAxis,
                datasets: [{
                    data: yAxis.map(function (c) {
                        return c[2];
                    }),
                    label: "Altitude",
                    borderColor: "#dc602c",
                    backgroundColor: "#FDF4EE",
                    fill: true
                }
                ]
            },
            options: {
                events: ['mousemove', 'mouseout'],
                onHover: (e) => {
                    const canvasPosition = getRelativePosition(e, chart);
                    const dataX = chart.scales.x.getValueForPixel(canvasPosition.x);
                    //if event from chart
                    if(isEmpty(e.native.relatedTarget)) {
                        moveMarker(yAxis[dataX < 0 ? 0 : dataX])
                    }
                },
                elements: {
                    point: {
                        radius: 0
                    },
                    line: {
                        tension: 0.4,
                        borderWidth: 1
                    }
                },
                responsive: true,
                scales: {
                    x: {
                        ticks: {
                            display: true,
                            autoSkip: false,
                            callback: function(value, index, values) {
                                let distance = yAxis[value][3]
                                let previousDistance = value > 0 ? yAxis[value-1][3] : 0;
                                if(distance> previousDistance && distance%25 == 0){
                                    return distance;
                                }
                                return '';
                            }
                        },
                        title: {
                            display: true,
                            text: 'Distance (km)'
                        },
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Altitude (m)'
                        },
                        suggestedMax: 100
                    }
                },
                maintainAspectRatio: false,
                interaction: {
                    intersect: false,
                },

                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                var label = context.dataset.label || '';

                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += context.parsed.y + 'm';
                                }
                                if (context.parsed.x !== null) {
                                    label += ' - Distance : ' + xAxis[context.parsed.x] + 'km';
                                }
                                return label;
                            },
                            title: function (tooltipItem) {
                                return 'Profil altimétrique'
                            }
                        }
                    }
                }
            }
        });
    }

    function getIcon(icon, color){
        return L.divIcon({
            html: '<span  class="fa-stack fa-2x" style="vertical-align: top;">\n' +
                '        <i style="color:'+color+'" class="fa fa-map-marker fa-stack-2x"></i>\n' +
                '        <i style="color:white;" class="inner-icon fas '+icon+' fa-stack-1x"></i>\n' +
                '</span>',
            iconSize: [60, 48],
            iconAnchor:   [30, 48],
        });
    }

    function toFixed(num, fixed) {
        var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
        return num.toString().match(re)[0];
    }
}

let openStreetMapTileLayer = (zoom = 19) => L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: zoom,
        attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
    })

let ignTileLayer = () => L.tileLayer('https://wxs.ign.fr/{ignApiKey}/geoportail/wmts?' +
        '&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&TILEMATRIXSET=PM' +
        '&LAYER={ignLayer}&STYLE={style}&FORMAT={format}' +
        '&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}',
        {
            ignApiKey: 'pratique',
            ignLayer: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
            style: 'normal',
            format: 'image/png',
            service: 'WMTS',
        });

carto(stops, kml, types)
